<template>
  <Modal
    width="920"
    title="选择橙子建站落地页"
    class-name="vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-ok="asyncSelect"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="!show"></Spin>
    <Table height="440" stripe highlight-row :columns="linkTableHead" :data="linkDataList" @on-current-change="bindCurrentRow"></Table>
    <Page class="page-index" show-total :current.sync="pageIndex" :total="total" :page-size="pageSize" @on-change="changePageIndex" />
  </Modal>
</template>
<script>
import { siteGetList } from '@/api/toutiao.model'
export default {
  name: 'siteLandpage',
  props: {
    value: {
      type: Boolean
    },
    account: {
      type: [Number, String]
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 请求数据
    getData() {
      siteGetList({
        account: this.account,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then((data) => {
        this.show = true
        if (data) {
          this.linkDataList = data.list
          this.total = data.page_info.total_number
        }
      })
    },
    bindGetData(val) {
      if (val) {
        this.getData()
      } else {
        this.currentRow = undefined
        this.pageIndex = 1
      }
    },
    changePageIndex(index) {
      this.show = null
      this.pageIndex = index
      this.getData()
    },
    // 选中当前项
    bindCurrentRow(currentRow) {
      this.currentRow = currentRow
    },
    asyncSelect() {
      if (!this.currentRow) {
        this.$Message.warning('您未选择一个落地页')
        return false
      }
      this.$emit('on-select', this.currentRow)
    }
  },
  data() {
    return {
      show: null, // 请求状态
      total: 0, // 分页信息
      pageIndex: 1,
      pageSize: 10,
      linkDataList: [],
      linkTableHead: [
        {
          key: 'siteId',
          title: '落地页ID',
          width: 180
        },
        {
          key: 'name',
          title: '落地页名称',
          width: 170
        },
        {
          key: 'url',
          title: '落地页地址'
        },
        {
          key: 'thumbnail',
          title: '预览图',
          width: 90,
          render: (h, params) => {
            const url = params.row.url
            return h(
              'a',
              {
                attrs: {
                  href: url,
                  target: '_blank'
                }
              },
              '查看'
            )
          }
        }
      ]
    }
  }
}
</script>
<style lang='scss' scoped>
.page-index {
  margin-top: 12px;
  text-align: right;
}
</style>
